/** Convert (color key, density 0-100) → rgba CSS string for hero glass card. */
export const cardBackgroundColor = (color, density) => {
  if (color === "none") return "transparent";
  const d = Math.max(0, Math.min(100, density ?? 8)) / 100;
  const rgb = {
    white: "255,255,255",
    black: "0,0,0",
    red: "230,0,0",
    gray: "47,49,54",
  }[color || "white"] || "255,255,255";
  return `rgba(${rgb},${d})`;
};

/** Compute style object for the glass card behind hero text. */
export const heroCardStyle = (c) => ({
  backgroundColor: cardBackgroundColor(c.hero_card_color, c.hero_card_density),
  backdropFilter: `blur(${c.hero_blur ?? 2}px)`,
  WebkitBackdropFilter: `blur(${c.hero_blur ?? 2}px)`,
});
